import axios from "axios";
import { ENDPOINTS } from "./ENDPOINT.js";

export const ExpenseService = {
    
    getAllExpense: async () => {
        try {
            const response = await axios.get(ENDPOINTS.GET_EXPENSE);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },

    createExpense: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.EXPENSE, data);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },

    editExpense: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.EDIT_EXPENSE, data);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },

    deleteExpenseItem: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.DELETE_EXPENSE_ITEM}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error delete expense items:", error);
            throw error; 
        }
    },

    deleteExpense: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.DELETE_EXPENSE}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error delete expense items:", error);
            throw error; 
        }
    },

    // get service request data

    getAllServiceRequest: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.SER_REQ}`);
            return response.data;
        } catch (error) {
            console.error("Error delete expense items:", error);
            throw error; 
        }
    },
    

}